import { FooterController } from './footer.controller';
import { FooterComponentProps } from './footer.model';

const Footer = (props: FooterComponentProps): JSX.Element => {
  return <FooterController {...props} />;
};
export default Footer;
